
const LiveChatInfo = {
        license: 11222357,
        group: 7
};
exports.LiveChatInfo = LiveChatInfo;